import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { SystemUserRole } from '@inshuwa-client/models';
import { ClientsService } from 'libs/core/src/lib/services/clients.service';
import { GetDecodedToken } from 'libs/core/src/lib/utils/token-decode';
import { map, of } from 'rxjs';

export const clientLoginGuard = () => {
  const nzModalService = inject(NzModalService);
  const clientService = inject(ClientsService);
  const decoded = GetDecodedToken();

  if (!decoded) {
    inject(Router).navigate(['/'], { replaceUrl: true });
    return of(false);
  }

  const { roles, clientId } = decoded;
  return clientService.getClientById(clientId).pipe(
    map((value) => {
      if (!roles.includes(SystemUserRole.client)) {
        nzModalService.error({
          nzTitle: 'Unauthorized',
          nzContent: 'You are not authorized to access this page',
        });
        return false;
      }
      clientService.saveClient(value);
      return true;
    }),
  );
};
